export enum ResultTypes {
  Err = "Err",
  Ok = "Ok",
}

export enum ErrorKind {
  UnknownMessage = "unknown-message",
  ParseError = "parse-error",
  SocketError = "socket-error",
  Timeout = "timeout",
  FetchError = "fetch-error",
  ServerError = "server-error",
  JSONError = "json-error",
  MalformedMessage = "malformed-message",
}

interface LockError {
  type: typeof ResultTypes.Err;
  kind: ErrorKind;
  info?: any;
}

interface Ok<T> {
  type: typeof ResultTypes.Ok;
  value: T;
}

export type Result<T> = Ok<T> | LockError;

export function err<T>(kind: ErrorKind, info?: any): Result<T> {
  return {
    type: ResultTypes.Err,
    kind,
    info,
  };
}

export function ok<T>(value: T): Result<T> {
  return {
    type: ResultTypes.Ok,
    value,
  };
}
